import React from "react";

function Uploaded({ name }) {
  return (
    <div className="total_container_uploadFile_sucess">
      <div className="detailsUploaded ">
        <div className="name">{name}</div>
        <div className="logo_upload_sucess">
          <img
            className="succesUploadLogo"
            alt=""
            src="/group-img/sucessUploadLogo.svg"
          ></img>
        </div>
      </div>
    </div>
  );
}

export default Uploaded;
